import { render } from "./portfolioView.vue?vue&type=template&id=08dec944"
import script from "./portfolioView.vue?vue&type=script&lang=js"
export * from "./portfolioView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__